const api = require('./api-caller')
const baseEndpoint = '/transactions'

module.exports = {
  getDataAssetTransactions: (id) => {
    const endpoint = `${baseEndpoint}/${id}`
    return api(endpoint, 'GET')
  }
}
